import { call, takeLatest } from "redux-saga/effects";
import * as routeApis from "../apis/routeApis"
import { COMPLETE_ROUTE, CREATE_ROUTE, DROPERS_DROPDOWN, EDIT_ROUTE, LIST_ROUTE, PRODUCT_ROUTE_LIST, STORES_DROPDOWN, VIEW_ROUTE } from "../actions/types";


export function* createRouteWorker(action) {
    try {
        const res = yield call(routeApis.createRouteApi, action.data);
        if (res.status === 200) {
            yield action.onSuccess(res);
        } else {
            yield action.onError(res);
        }
    } catch (error) {
        yield action.onError({
            data: {
                message: error,
            },
        });
    }
}

export function* editRouteWorker(action) {
    try {
        const res = yield call(routeApis.editRouteApi, action.data);
        if (res.status === 200) {
            yield action.onSuccess(res);
        } else {
            yield action.onError(res);
        }
    } catch (error) {
        yield action.onError({
            data: {
                message: error,
            },
        });
    }
}


export function* listRouteWorker(action) {
    try {
        const res = yield call(routeApis.listRouteApi, action.data);
        if (res.status === 200) {
            yield action.onSuccess(res);
        } else {
            yield action.onError(res);
        }
    } catch (error) {
        yield action.onError({
            data: {
                message: error,
            },
        });
    }
}

export function* viewRouteWorker(action) {
    try {
        const res = yield call(routeApis.viewRouteApi, action.data);
        if (res.status === 200) {
            yield action.onSuccess(res);
        } else {
            yield action.onError(res);
        }
    } catch (error) {
        yield action.onError({
            data: {
                message: error,
            },
        });
    }
}

export function* productsRouteListWorker(action) {
    try {
        const res = yield call(routeApis.productsRouteListApi, action.data);
        if (res.status === 200) {
            yield action.onSuccess(res);
        } else {
            yield action.onError(res);
        }
    } catch (error) {
        yield action.onError({
            data: {
                message: error,
            },
        });
    }
}

export function* completeRouteWorker(action) {
    try {
        const res = yield call(routeApis.completeRouteApi, action.data);
        if (res.status === 200) {
            yield action.onSuccess(res);
        } else {
            yield action.onError(res);
        }
    } catch (error) {
        yield action.onError({
            data: {
                message: error,
            },
        });
    }
}

export function* dropersDropdownWorker(action) {
    try {
        const res = yield call(routeApis.dropersDropdownApi, action.data);
        if (res.status === 200) {
            yield action.onSuccess(res);
        } else {
            yield action.onError(res);
        }
    } catch (error) {
        yield action.onError({
            data: {
                message: error,
            },
        });
    }
}

export function* storesDropdownWorker(action) {
    try {
        const res = yield call(routeApis.storesDropdownApi, action.data);
        if (res.status === 200) {
            yield action.onSuccess(res);
        } else {
            yield action.onError(res);
        }
    } catch (error) {
        yield action.onError({
            data: {
                message: error,
            },
        });
    }
}



/**Watcher Func */
export function* createRouteWatcher() {
    yield takeLatest(CREATE_ROUTE, createRouteWorker);
}
export function* editRouteWatcher() {
    yield takeLatest(EDIT_ROUTE, editRouteWorker);
}
export function* listRouteWatcher() {
    yield takeLatest(LIST_ROUTE, listRouteWorker);
}
export function* viewRouteWatcher() {
    yield takeLatest(VIEW_ROUTE, viewRouteWorker);
}
export function* productsRouteListWatcher() {
    yield takeLatest(PRODUCT_ROUTE_LIST, productsRouteListWorker);
}
export function* completeRouteWatcher() {
    yield takeLatest(COMPLETE_ROUTE, completeRouteWorker);
}
export function* dropersDropdownWatcher() {
    yield takeLatest(DROPERS_DROPDOWN, dropersDropdownWorker);
}
export function* storesDropdownWatcher() {
    yield takeLatest(STORES_DROPDOWN, storesDropdownWorker);
}